import React from "react";
import { Hero } from "@/components/home/Hero";

import { TripInsurance } from "@/components/home/TripInsurance";

import { MainLayout } from "@/layouts/home/MainLayout";

import Terms from "@/components/termsandconditions/terms";

const TermsAndConditions = () => {
	return (
		<div>
			<MainLayout>
				{/* <Hero />
				<TripInsurance /> */}
				<Terms />
				{/* <Payless />
				<Claim />
				<Why />
				<Faq />
				<DownloadBanner /> */}
			</MainLayout>
		</div>
	);
};

export default TermsAndConditions;
